<template>
  <div>
    <template v-if="!session.loadingStatusFinished">
      <v-progress-circular indeterminate color="grey"></v-progress-circular>
    </template>
    <template v-else-if="session.canLoadingAgain">
      <v-btn dark rounded depressed block color="light-blue" @click="getSessionStatus()">
        <v-icon>mdi-replay</v-icon>{{ $t('session_table_retry') }}
      </v-btn>
    </template>
    <template v-else>
      <div v-if="session.status == 'over'" class="grey--text text-title">
        {{ $t(`session_table_end${campaign.isLottery ? '_lottery' : ''}`) }}
      </div>
      <div v-if="session.status == 'soldout'" class="grey--text text-title">{{ $t('session_table_soldout') }}</div>
      <div v-if="session.status == 'unavailable'" class="grey--text text-title">{{ $t('status_unavailable') }}</div>
      <div v-if="session.status == 'lock'" class="grey--text text-title">{{ $t(`group_seat_lock${campaign.isLottery ?
      '_lottery' : ''}`) }}</div>
      <template v-if="['onsale'].includes(session.status)">
        <v-btn dark rounded depressed class="nextBtn float-right" block @click="buyTicket(session)">{{
      $t(`session_table_buy_cta${campaign.isLottery ? '_lottery' : ''}`) }}</v-btn>
      </template>
      <template v-if="session.status == 'pending'">
        <v-btn outlined rounded depressed block color="primary" maxWidth="120" @click="buyTicket">{{
      $t(`session_table_pending${campaign.isLottery ? '_lottery' : ''}`) }}</v-btn>
      </template>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    eventId: {
      type: String,
      default: "",
    },
    session: {
      type: Object,
      default: {},
    },
  },
  computed: {
    ...mapGetters({
      campaign: "event/campaign",
    }),
  },
  methods: {
    ...mapActions({
      showLogin: "login/show",
      setSession: "session/setSession",
      setAreaAssignment: "order/setAreaAssignment",
    }),
    getSessionStatus() {
      this.$emit("emitGetSessionStatus");
    },
    buyTicket(session) {
      // 活動_{代入活動名稱} 1_{代入場次名稱}
      this.setSession(this.session)
      this.$router
        .push({
          name: "Order1",
          params: { eventId: this.eventId, sessionId: this.session.sessionId },
        })
        .catch(() => { });
    },
  },
};
</script>

<style lang="scss" scoped>
.canbuyBtn {
  background-image: linear-gradient(left, $primary-1, $primary-1) !important;
}
</style>
